import { v4 as uuid } from 'uuid';

export type DataInputColumnType = 'number' | 'text' | 'boolean';

export interface DataInputColumnDef {
  readonly id: string;
  readonly header: string;
  readonly colType: DataInputColumnType;
  readonly width?: number;
}

export type DataInputCellValue = number | string | boolean | null;
export type DataInputRow = Record<string, DataInputCellValue>;

export interface DataInputConfig {
  readonly columns: DataInputColumnDef[];
  readonly rows: DataInputRow[];
  readonly rowCount?: number;
  readonly rowLabels?: string[];
  readonly editableHeaders?: boolean;
  readonly allowAddColumns?: boolean;
  readonly allowAddRows?: boolean;
  readonly title?: string;
}

export function createDefaultDataInputConfig(): DataInputConfig {
  return {
    columns: [{ id: uuid(), header: 'x', colType: 'number' }],
    rows: [],
    editableHeaders: true,
    allowAddColumns: false,
    allowAddRows: true,
  };
}
